const styles = {
  headerContainer: {
    display: "flex",
    alignItems: "center",
    padding: "10px",
    background: "transparent",
    boxShadow: "none",
        justifyContent: "space-between",
    marginTop: "10px"
  },
  spacer: {
    flexGrow: 1,
  },
  userContainer: {
    display: "flex",
    alignItems: "center",
  },
  avatar: {
    width: "61.775px",
    height: "60px",
    flexShrink: 0,
    borderRadius: "10px",
    background: "#D9D9D9",
  },
  userInfo: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    flexShrink: 0,
    marginLeft: "10px",
    width: "90.13px",
    height: "30.371px",
  },
  userName: {
    color: "var(--Greys-Blue-Grey-900, #151D48)",
    fontFamily: "Poppins",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
  },
  userTitle: {
    color: "#40424B",
    fontFamily: "Poppins",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
    marginTop: "7px",
  },
};

export default styles;
